import React from "react";
import PropTypes from "prop-types";
import ItemMenu from "../ItemMenu/ItemMenu";
import ItemMenuSolutionPreview from "../ItemMenuSolutionPreview/ItemMenuSolutionPreview";
import { trackSubmenuClick, trackSolutionFilterClick } from "../../lib/analytic/trackMainMenu";

const SubMenuCapabilities = ({
  childrenItems,
  setShowMainMenu,
  currentMenu,
  setCurrentMenu,
  buttonBackText,
  setButtonBackText,
  isMobile,
  buttonCloseFocus,
  isCapabilitiesMenu,
  isExpanded,
}) => {
  const backButtonRef = React.useRef(null);
  const [solutionPreview, setSolutionPreview] = React.useState(null);
  const [currentFilter, setCurrentFilter] = React.useState(null);
  const [capabilitiesMenu] = React.useState({
    ...currentMenu,
    backbuttonText: buttonBackText
  });

  // Check if menu item have submenu.
  const haveChildren =
    Object.keys(childrenItems).length !== 0 &&
    childrenItems.constructor === Object;
  // Prepare submenu array.
  const subMenus = haveChildren && Object.values(childrenItems?.columns);
  // Subtitle for submenus.
  const subtitleMenus = childrenItems?.subtitle;
  // Prepare link after sub menu.
  const linkBottom = childrenItems?.linkBottom;
  // Render submenu links.
  const printChildrenItems = (viewMode, links) =>
    links.map((link) => (
        <ItemMenu
          key={link.id}
          link={link}
          isMobile={isMobile}
          viewMode={viewMode}
          handleSolutionMouseOver={showSolutionPreview}
          handleSolutionMouseOut={clearSolutionPreview}
          handleSolutionFilter={filterSolutions} />
    ));

    // Handled solution description display.
    const showSolutionPreview = (title, image, body) => {
        setSolutionPreview(prev => ({
            title: title,
            image: image,
            body: body
        }));
    }

    const clearSolutionPreview = () => {
        setSolutionPreview(null);
    }

    function splitToColumns(array, columns) {
        const linksPerColumn = Math.ceil(array.length / columns);
        const result = [];
        for (let i = 0; i < array.length; i += linksPerColumn) {
            result.push(array.slice(i, i + linksPerColumn));
        }
        return result;
    }

    const [originalSolutionsLinks] = React.useState(() => {
        for (const column of subMenus) {
            for (const childItem of column) {
                if (childItem['viewMode'] === 'menu_solution') {
                    return childItem.links;
                }
            }
        }
    });
    const [solutionsByColumn, setSolutionsByColumn] = React.useState(splitToColumns(originalSolutionsLinks, 2));

    function filterSolutions(term, domain_url) {
        const filteredSolutions = originalSolutionsLinks.filter(solution => solution.capabilities.includes(term));
        setCurrentFilter({
            term: term,
            url: domain_url,
        });

        if (isMobile) {
            const solutionsMenu = {
                columns: [
                    [{
                        links: filteredSolutions,
                        viewMode: 'menu_solution',
                    }],
                ],
                viewMode: 'menu_capabilities',
            }
            setCurrentMenu(solutionsMenu);
            setButtonBackText(`${term} Solutions`);
            backButtonRef.current.focus();
        }
        else {
            setSolutionsByColumn(splitToColumns(filteredSolutions, 2));
        }
        trackSolutionFilterClick(term);
    }

    function clearSolutionsFilter() {
        setCurrentFilter(null);
    }

    React.useEffect(() => {
        if (!currentFilter) {
            setSolutionsByColumn(splitToColumns(originalSolutionsLinks, 2));
        }
    },[currentFilter, originalSolutionsLinks]);
    
    React.useEffect(() => {
        if (isExpanded === false) {
            setCurrentFilter(null);
        }
    },[isExpanded]);

  // Func for back to main menu from submenu.
  const backToMainMenu = () => {
    if (currentFilter) {
        setCurrentMenu(capabilitiesMenu);
        setButtonBackText(capabilitiesMenu.backbuttonText);
        clearSolutionsFilter();

        // Set focus to close btn if out of submenu.
        buttonCloseFocus.current.focus();
    }
    else {
        setShowMainMenu(true);
        // Set focus to close btn if out of submenu.
        buttonCloseFocus.current.focus();
    }
  };
  const subMenuColWidthClass = childrenItems?.colWidthSetting ? childrenItems.colWidthSetting : "even";
  const capabilitiesSubMenuClass = isCapabilitiesMenu ? "capabilities" : "";

  return (
    <div className={`submenu__inner col-width-${subMenuColWidthClass} ${capabilitiesSubMenuClass}`} role="presentation">
      {isMobile && (
        <div className="submenu__overlay-btn mt-n40" role="presentation">
          <button
            /* eslint-disable-next-line jsx-a11y/no-autofocus */
            autoFocus
            onClick={backToMainMenu}
            type="button"
            className="submenu__move-back font-600 mt-4 mb-40"
            aria-label="Back to main menu"
            ref={backButtonRef}
          >
            <span aria-hidden="true">{buttonBackText}</span>
          </button>
        </div>
      )}
      {subtitleMenus && (
        <p className="mb-0 subtitle submenu__subtitle-menus mb-16">
          {subtitleMenus}
        </p>
      )}
      {subMenus &&
        subMenus.map((column,index) => {
          const firstChild = column[0];
          return (
            <div
              className={`submenu__wrap-menu submenu__wrap-menu--capabilities ${firstChild?.extraClass ? firstChild.extraClass : ""}`}
              key={'submenu__column-' + index}
              role="presentation"
            >
              {column.map((childItem) => {
                const titleClass = childItem.image
                  ? "font-600 submenu__text"
                  : "subtitle mb-16";
                return (
                  <div className="submenu__item"
                      key={childItem.id}
                      role="presentation"
                      >
                    <div className="submenu__description" role="presentation">
                      <div className="submenu__description__inner" role="presentation">
                        {childItem.image && (
                          <div
                            role="presentation"
                            className="submenu__image"
                            /* eslint-disable-next-line react/no-danger */
                            dangerouslySetInnerHTML={{
                              __html: childItem.image,
                            }}
                          />
                        )}
                        {childItem.subtitle && (
                            <>
                                {childItem.viewMode !== 'menu_solution' &&
                                    <p className={`mb-0 ${titleClass}`} aria-hidden="true">
                                        {currentFilter && childItem.viewMode === 'menu_solution' && currentFilter.term} {childItem.subtitle}
                                    </p>
                                }
                                {!isMobile && childItem.viewMode === 'menu_solution' &&
                                <div className="d-flex justify-items-between">
                                    <p className={`mb-0 ${titleClass}`} aria-hidden="true">
                                        {currentFilter && childItem.viewMode === 'menu_solution' && currentFilter.term} {childItem.subtitle}
                                    </p>
                                    {currentFilter && childItem.viewMode === 'menu_solution' && <button className="ml-auto button button--clear-filter" onClick={clearSolutionsFilter}>Clear Filter</button>}
                                </div>
                                }
                            </>
                        )}
                      </div>
                    </div>

                    {(!isMobile && childItem.viewMode === 'menu_solution') && (
                        <div class="grid grid--cols-sm-1 grid--cols-lg-2 submenu-child__column-wrapper">
                            {solutionsByColumn.map((columnItems, index) => (
                                <div
                                    className={`submenu-child__column grid__col mb-0`}
                                    key={'childitem__column-' + index}
                                    role="presentation"
                                >
                                    <ul aria-label={childItem.subtitle} role="menu" className={`submenu-child-wrapper-${childItem.viewMode}`}>
                                        {printChildrenItems(childItem.viewMode, columnItems)}                      
                                    </ul>
                                    {currentFilter && index === 0 && (
                                        <a href={currentFilter.url} aria-label={currentFilter.term} className={`sub-link sub-link--default link--tertiary link--small`}>Explore All {currentFilter.term}</a>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                    {(isMobile && childItem.viewMode === 'menu_solution' && currentFilter) && (
                        <>
                            <ul aria-label={childItem.subtitle} role="menu" className={`submenu-child-wrapper-${childItem.viewMode}`}>
                                {printChildrenItems(childItem.viewMode, childItem.links)}                      
                            </ul>
                            <a href={currentFilter.url} aria-label={currentFilter.term} className={`sub-link sub-link--default link--tertiary link--small`}>Explore All {currentFilter.term}</a>
                        </>
                    )}
                     {(childItem.viewMode !== 'menu_solution') && (
                        <ul aria-label={childItem.subtitle} role="menu" className={`submenu-child-wrapper-${childItem.viewMode}`}>
                         {printChildrenItems(childItem.viewMode, childItem.links)}                      
                        </ul>
                    )}
                    
                    {solutionPreview && index === 1 &&
                      <ItemMenuSolutionPreview content={solutionPreview} />
                    }
                  </div>
                )
              })}
            </div>
          );
        })}
      {linkBottom && (
        <div className="submenu__link-bottom-wrap pt-lg-16 pb-lg-16 d-lg-flex justify-content-center">
          <a
            className="link link--tertiary link--small"
            href={linkBottom.url}
            onClick={() => {
              trackSubmenuClick(linkBottom.text, linkBottom.url);
            }}
          >
            {linkBottom.text}
          </a>
        </div>
      )}
    </div>
  );
};

SubMenuCapabilities.defaultProps = {
  setShowMainMenu: null,
  buttonBackText: "",
  isMobile: false,
  buttonCloseFocus: {},
};

SubMenuCapabilities.propTypes = {
  childrenItems: PropTypes.object.isRequired,
  setShowMainMenu: PropTypes.func,
  buttonBackText: PropTypes.string,
  isMobile: PropTypes.bool,
  buttonCloseFocus: PropTypes.object,
  isCapabilitiesMenu: PropTypes.bool,
};

export default SubMenuCapabilities;
